import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { includes, without, find } from 'lodash';

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work should consider refactoring/removing this to
 * improve the health of the codebase.
 */
class GridSettings extends Component {
  constructor(props) {
    super(props);

    this.setPageSize = this.setPageSize.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  setPageSize(event) {
    const value = parseInt(event.target.value, 10);
    this.props.setPageSize(value);
  }

  handleChange(event) {
    const columnName = event.target.dataset
      ? event.target.dataset.name
      : event.target.getAttribute('data-name');
    if (
      event.target.checked === true &&
      includes(this.props.selectedColumns, columnName) === false
    ) {
      this.props.selectedColumns.push(columnName);
      this.props.setColumns(this.props.selectedColumns);
    } else {
      /* redraw with the selected columns minus the one just unchecked */
      this.props.setColumns(without(this.props.selectedColumns, columnName));
    }
  }

  render() {
    let nodes = [];
    // don't show column selector if we're on a custom component
    if (this.props.useCustomComponent === false) {
      nodes = this.props.columns.map((col) => {
        const checked = includes(this.props.selectedColumns, col);
        // check column metadata -- if this one is locked make it disabled and don't put an onChange event
        const meta = find(this.props.columnMetadata, { columnName: col });
        let displayName = col;

        if (
          typeof meta !== 'undefined' &&
          typeof meta.displayName !== 'undefined' &&
          meta.displayName != null
        ) {
          displayName = meta.displayName;
        }

        if (typeof meta !== 'undefined' && meta != null && meta.locked) {
          return (
            <div className="column checkbox">
              <label>
                <input
                  type="checkbox"
                  disabled
                  name="check"
                  checked={checked}
                  data-name={col}
                />
                {displayName}
              </label>
            </div>
          );
        } else if (
          typeof meta !== 'undefined' &&
          meta != null &&
          typeof meta.visible !== 'undefined' &&
          meta.visible === false
        ) {
          return null;
        }
        return (
          <div
            className="griddle-column-selection checkbox"
            key={col}
            style={
              this.props.useGriddleStyles
                ? { float: 'left', width: '20%' }
                : null
            }
          >
            <label>
              <input
                type="checkbox"
                name="check"
                onChange={this.handleChange}
                checked={checked}
                data-name={col}
              />
              {displayName}
            </label>
          </div>
        );
      });
    }

    const toggleCustom = this.props.enableToggleCustom ? (
      <div className="form-group">
        <label htmlFor="maxRows">
          <input
            type="checkbox"
            checked={this.props.useCustomComponent}
            onChange={this.props.toggleCustomComponent}
          />{' '}
          {this.props.enableCustomFormatText}
        </label>
      </div>
    ) : (
      ''
    );

    const setPageSize = this.props.showSetPageSize ? (
      <div>
        <label htmlFor="maxRows">
          {this.props.maxRowsText}:
          <select onChange={this.setPageSize} value={this.props.resultsPerPage}>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </label>
      </div>
    ) : (
      ''
    );

    return (
      <div
        className="griddle-settings"
        style={
          this.props.useGriddleStyles
            ? {
                backgroundColor: '#FFF',
                border: '1px solid #DDD',
                color: '#222',
                padding: '10px',
                marginBottom: '10px',
              }
            : null
        }
      >
        <h6>{this.props.settingsText}</h6>
        <div
          className="griddle-columns"
          style={
            this.props.useGriddleStyles
              ? {
                  clear: 'both',
                  display: 'table',
                  width: '100%',
                  borderBottom: '1px solid #EDEDED',
                  marginBottom: '10px',
                }
              : null
          }
        >
          {nodes}
        </div>
        {setPageSize}
        {toggleCustom}
      </div>
    );
  }
}

GridSettings.defaultProps = {
  columns: [],
  columnMetadata: [],
  selectedColumns: [],
  settingsText: '',
  maxRowsText: '',
  resultsPerPage: 0,
  enableToggleCustom: false,
  useCustomComponent: false,
  useGriddleStyles: true,
  toggleCustomComponent() {},
};

GridSettings.propTypes = {
  setPageSize: PropTypes.func,
  toggleCustomComponent: PropTypes.func,
  setColumns: PropTypes.func,
  selectedColumns: PropTypes.array,
  columns: PropTypes.array,
  useCustomComponent: PropTypes.bool,
  useGriddleStyles: PropTypes.bool,
  showSetPageSize: PropTypes.number,
  resultsPerPage: PropTypes.number,
  maxRowsText: PropTypes.string,
  settingsText: PropTypes.string,
  enableCustomFormatText: PropTypes.string,
};

export { GridSettings };
